<template>
    <form-dialog :value="value" @input="$emit('input', $event)">
        <template #activator="bindings">
            <slot name="activator" v-bind="bindings"></slot>
        </template>
        <template #default="{ close }">
            <SetAmazonAssumeRoleCredentialsCard :disabled="disabled" :loading="loading" :value="edit">
                <template #actions="{ form, isValid, clear, formId }">
                    <back-button @click="close().then(clear)"></back-button>
                    <v-spacer></v-spacer>
                    <slot name="actions" :form="form" :formId="formId" :isValid="isValid" :clear="clear" :close="close">
                    </slot>
                </template>
            </SetAmazonAssumeRoleCredentialsCard>
        </template>
    </form-dialog>
</template>

<script>
import SetAmazonAssumeRoleCredentialsCard from '@/components/Settings.CloudAccounts/Amazon/SetAmazonAssumeRoleCredentialsCard.vue';
export default {
    props: ['value', 'loading', 'disabled', 'edit'],
    components: { SetAmazonAssumeRoleCredentialsCard },
    methods: {
        open() {
            this.$emit('input', true);
        },
    },
};
</script>